import { Button, Chip, Dialog, DialogContent, DialogTitle, FormControlLabel, Grid, IconButton, InputAdornment, MenuItem, Skeleton, Switch, TextField, Tooltip } from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import React, { useContext, useEffect, useState } from 'react'
import {useTranslate } from 'react-admin';
import { FormProvider, useForm } from 'react-hook-form';
import { MultiAutocompleteInput } from 'src/components/uiElements/fields/MultiAutocompleteInput';
import { reservationServices } from 'src/services/sales/reservation/reservation.service';
import { Filters, PostFilterFormReservation } from './logic/Filters';
import { ITEM_PERMISSION_ENTITY, PERMISSION_LIST, PERMISSION_SHOW, PERMISSION_SMARTBOOK } from 'src/helper/Permission';
import { hasPermissionFunction } from 'src/helper/HasPermission';
import { useReportData } from './logic/useReportData';
import { reportingServices } from 'src/services/sales/reporting/reporting.service';
import { MonthlyFrequenciesDialog } from './logic/MonthlyFrequenciesDialog';
import { DUE_DATE_RANGE_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { getDateRanges } from './logic/AnalysysPeriodLogic';
import { ReportingContext } from './logic/ReportingContext';

export const ReportingForm = ({reportId = null, setOpenEditDialog, isShow}) => {
  const translate = useTranslate()
  const [loadingEditInfo, setLoadingEditInfo] = useState(false)
  const [uniqueDateFrequency, setUniqueDateFrequency] = useState('')
  const [analysisPeriodExample, setAnalysisPeriodExample] = useState({})
  const [reportToEdit, setReportToEdit] = useState(null)
  const [dynamicDateValidation, setDynamicDateValidation] = useState(false)
  const weekDays = [
    'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'
  ]
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);
  const maxDate = new Date();
  maxDate.setDate(today.getDate() + 30);
  const [displayedFilters, setFilters] = useState({
    provider_code__in: false,
    item__status__in:false,
    billing_status:false,
    billing_automatic:false,
    status__in:false,
    item__payment_status__in:false,
    item_billing_status__in:false,
    tag__id__in:false,
    item__source_id__in:false,
    sales_id__in:false,
    number__ilike_in:false,
    pax:false,
    business_unit__country_id__in:false,
    item__product_id__in:false,
    supplier_id__in:false,
    item__has_smartbook:false,
    business_unit__salesperson_hash_user__in:false,
    business_unit__hash_user__in:false,
    product_type_id__in:false,
    business_unit_id__in:false,
    work_unit_id__in:false,
    user__hash_user__in:false,
    item__is_billable:false,
    item__has_flexible_rate:false,
    item__has_ancillary_baggage:false,
    date_in:false,
    item__autocancel_date:false,
    item__updated_at:false,
    billing_date:false,
    item__due_date_final:false,
    cancel_info__date:false,
    create_at:false,
    item__created_at:false,
    billing_base__in:false,
    pax_item__ticket_number__in:false,
    item__date_out:false,
    billing_has_receipt:false,
    item__date_in:false
  })

  const [form, setForm] = useState({
    name:'',
    type:'',
    subtype:1,
    user_to:[],
    date_filter_type:0,
    type_frequency:'',
    date_filter_range:'',
    dateFrom:null,
    dateTo:null,
    is_active:true,
    configuration:1,
    number__in:null,
    custom__gte:null,
    custom__lte:null,
    frequency:[]
  })

  const originalFilters = [
    { source: 'provider_code__in', name: 'ra.field.provider_code' },
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'billing_base__in', name: 'ra.field.billing_base' }]
    :[]),
    { source: 'pax_item__ticket_number__in', name: 'ra.field.item_ticket_number' },
    { source: 'item__status__in', name: 'ra.field.item_status' },
    ...(hasPermissionFunction('sales', PERMISSION_LIST)
      ? [{ source: 'billing_status', name: 'ra.field.billing_status' }]
      : []),
    ...((hasPermissionFunction('sales', PERMISSION_LIST) && hasPermissionFunction('reporting', 'internal'))
      ? [{ source: 'billing_automatic', name: 'ra.field.billing_automatic' }]
      : []),
    { source: 'status__in', name: 'ra.field.reservation_status' },
    { source: 'item__payment_status__in', name: 'ra.field.payment_status' },
    ...(hasPermissionFunction('sales', PERMISSION_LIST)
      ? [{ source: 'item_billing_status__in', name: 'ra.field.item_billing_status' }]
      : []),
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'tag__id__in', name: 'ra.field.tags' }]
    :[]),
    { source: 'item__source_id__in', name: 'ra.field.source' },
    ...(hasPermissionFunction('sales', PERMISSION_LIST)
      ? [{ source: 'sales_id__in', name: 'ra.field.tma_business' }]
      : []),
    { source: 'number__ilike_in', name: 'ra.field.reservation_number' },
    { source: 'pax', name: 'ra.field.passenger' },
    ...(hasPermissionFunction('reporting', 'internal')
    ? [{ source: 'business_unit__country_id__in', name: 'ra.field.country' }]
    : []),
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'item__product_id__in', name: 'ra.field.product' }]
    :[]),
    { source: 'supplier_id__in', name: 'ra.field.supplier' },
    ...((hasPermissionFunction(ITEM_PERMISSION_ENTITY, PERMISSION_SMARTBOOK) && hasPermissionFunction('reporting', 'internal'))
      ? [{ source: 'item__has_smartbook', name: 'ra.field.smartbookTitle' }]
      : []),
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'business_unit__salesperson_hash_user__in', name: 'ra.field.commercial_responsible' }]
    :[]),
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'business_unit__hash_user__in', name: 'ra.field.manager_responsible' }]
    :[]),
    { source: 'product_type_id__in', name: 'ra.field.product_type' },
    ...(hasPermissionFunction('reporting', 'internal')
    ? [{ source: 'business_unit_id__in', name: 'ra.field.business_unit' }]
    :[]),
    ...(hasPermissionFunction('reporting', 'internal') 
    ? [{ source: 'work_unit_id__in', name: 'ra.field.work_unit' }]
    :[]),
    { source: 'user__hash_user__in', name: 'ra.field.seller_user' },
    ...((hasPermissionFunction('sales', PERMISSION_LIST) && hasPermissionFunction('reporting', 'internal'))
      ? [{ source: 'item__is_billable', name: 'ra.field.is_billable' }]
      : []),
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'item__has_flexible_rate', name: 'ra.field.flexi' }]
    :[]),
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'item__has_ancillary_baggage', name: 'ra.field.extra_baggage' }]
    :[]),
    { source: 'date_in', name: 'ra.field.date_first_service' },
    { source: 'create_at', name: 'ra.field.reserve_create_date' },
    ...(hasPermissionFunction('sales', PERMISSION_LIST)
    ? [{ source: 'item__autocancel_date', name: 'ra.field.autocancel_date' }]
    : []),
    { source: 'item__updated_at', name: 'ra.field.last_update_date' },
    ...(hasPermissionFunction('reporting', 'internal')
    ?[{ source: 'cancel_info__date', name: 'ra.field.supplier_due_date' }]
    :[]),
    ...(hasPermissionFunction(DUE_DATE_RANGE_PERMISSION_ENTITY, PERMISSION_SHOW)
    ? [{ source: 'billing_date', name: 'ra.field.billing_date' }]
    : []),
    ...(hasPermissionFunction(DUE_DATE_RANGE_PERMISSION_ENTITY, PERMISSION_SHOW)
    ? [{ source: 'item__due_date_final', name: 'ra.field.due_date' }]
    : []),
    { source: 'item__created_at', name: 'ra.field.item_create_date' },
    { source: 'item__date_out', name: 'ra.field.end_date' },
    ...(hasPermissionFunction('item', 'rebooker_view')
    ? [{ source: 'item__has_rebooker', name: 'ra.field.rebooker' }]
    : []),
    { source: 'billing_has_receipt', name: 'ra.field.receipt_generated' },
    { source: 'payment_type__in', name: 'ra.field.payment_type' },
  ]

  const applyOrder = (unorderedArray, field='label') =>{
    if(!Array.isArray(unorderedArray)){
      return []
    }
    if(field === 'name'){
      return unorderedArray?.sort((a, b) =>
        translate(a[field]).localeCompare(translate(b[field]), undefined, { sensitivity: 'base' })
      )
    }
    return unorderedArray?.sort((a, b) =>
      a[field].localeCompare(b[field], undefined, { sensitivity: 'base' })
    )
  }

  const [listFilters, setListFilters] = useState(applyOrder(originalFilters, 'name'))

  const [filterValues, setFilterValues] = useState({})
  const [usersList, setUserList] = useState([])
  const {types} = useContext(ReportingContext);
  const [openMonthlyDialog, setOpenMonthlyDialog] = useState(false)
  const [usersLoading, setLoadingUserList] = useState(false)
  const subtypes = useReportData(null,'subtypes')
  const datetypes = useReportData(null,'datetypes')
  const configurations = useReportData(null,'configurations')
  const sendingPeriods = useReportData(null,'sendingPeriods')
  const [activeChecked, setActiveChecked] = useState(true)
  const analisysPeriod = useReportData(null,'analisysPeriod')
  const [formError, setFormError] = useState({
    name:false,
    type:false,
    subtype:false,
    date_filter_type:false,
    type_frequency:false,
    date_filter_range:false,
    dateFrom:false,
    dateTo:false,
    configuration:false,
    number__in:false,
    frequency:false,
    custom__gte:false,
    custom__lte:false,
    payment_type__in:false
  })

  useEffect(()=>{
    let auxiliarFilters = listFilters
    changeFiltersBySubtype(auxiliarFilters)
  },[form.subtype])

  const changeFiltersBySubtype = (auxiliarFilters) =>{
    
    if(form.subtype === 1){
      auxiliarFilters = auxiliarFilters.filter(filt => filt.source !== 'create_at' && filt.source !== 'item__created_at')
      if(form.date_filter_type !== 0){
        auxiliarFilters.push({ source: 'create_at', name: 'ra.field.reserve_create_date' })
      }
      auxiliarFilters = auxiliarFilters.map(filt=>filt.name === 'ra.field.date_first_service' ? {...filt, source:'date_in'} : filt)
    } else {
      auxiliarFilters = auxiliarFilters.filter(filt => filt.source !== 'create_at' && filt.source !== 'item__created_at')
      if(form.date_filter_type  !== 7){
        auxiliarFilters.push({ source: 'item__created_at', name: 'ra.field.item_create_date' })
      }
      auxiliarFilters = auxiliarFilters.map(filt=>filt.name === 'ra.field.date_first_service' ? {...filt, source:'item__date_in'} : filt)
    }
    
    setListFilters(applyOrder(auxiliarFilters, 'name'))
  }

  const usersForm = useForm({
    defaultValues: {
      user_to:null
    },
  });

  useEffect(()=>{
    handleFormChange('is_active', activeChecked)
  },[activeChecked])

  const changeTypeDateFilters = (type_id) =>{
    let auxOriginalFilters = originalFilters.filter(filt=>form.subtype === 0 ? filt.source !== 'create_at' : filt.source !== 'item__created_at')
    if(form.configuration !== 2){
      auxOriginalFilters = auxOriginalFilters.filter(filt=>translate(filt.name) !== (datetypes?.find(type=>type.id === type_id)).label)
    }
    changeFiltersBySubtype(auxOriginalFilters)
    /* setListFilters(auxOriginalFilters) */
  }

  const buildUniqueDate = (day) =>{
    const today = new Date();
    const year = today.getFullYear();
    const month = today.getMonth();

    // If the given day is less than today’s day, assume it's next month
    const targetMonth = day < today.getDate() ? month + 1 : month;

    return new Date(year, targetMonth, day); // Correct order: year, month, day
  }

  useEffect(()=>{
    if(reportId){
      setLoadingEditInfo(true)
      reportingServices.getReportById(reportId).then(report=>{
        const reportValues = {
          name:report.name,
          type:report.type,
          subtype:report.subtype,
          user_to:report.user_to,
          date_filter_type:report.date_filter_type,
          type_frequency:report.type_frequency,
          date_filter_range:report.date_filter_range,
          dateFrom:null,
          dateTo:null,
          configuration:0,
          number__in:null,
          frequency:report.frequency.map(freq=>Number(freq))
        }
        setForm(reportValues)
        changeTypeDateFilters(report.date_filter_type)
        usersForm.setValue('user_to', report.user_to)
        setActiveChecked(report.is_active)
        let auxFilterKeysArray = {...displayedFilters}
        let auxFilterValuesArray = {...filterValues}
        if(report.filters){
          const custom_filters = {}
          for (const [key, value] of Object.entries(report.filters)) {
            if(key.includes('custom')){
              custom_filters[key] = value
            } 
            else if(key.includes('__gte') || key.includes('__lte')){
              if(key.includes('item__')){
                const key_parts = key.split('__')
                auxFilterKeysArray[key_parts[0] + '__' + key_parts[1]] = true
              } else {
                auxFilterKeysArray[key.split('__')[0]] = true
              }
              
            } else {
              auxFilterKeysArray[key] = true
            }
            auxFilterValuesArray[key] = value
          }
          setForm({...reportValues, ...custom_filters})
          setFilterValues(auxFilterValuesArray)
          setFilters(auxFilterKeysArray)
        }
        setReportToEdit(report)
        if(report.type_frequency === 3){
          setUniqueDateFrequency(buildUniqueDate(report.frequency[0]))

        }
        
      }).finally(()=>{
        setLoadingEditInfo(false)
      })
    } else {
      changeTypeDateFilters(form.date_filter_type)
    }
  },[])

  const stringfyFrequency = () =>{
    let auxFrequency = [...form.frequency]
    if(form.type_frequency === 1){
      auxFrequency = auxFrequency.map(item=>weekDays[item])
    } else if(form.type_frequency === 0){
      return translate('ra.message.every_day')
    }
    return auxFrequency.join(', ')
  }

  let searchTimeout
  const getUserB2 = async (user, length = 2) => {
    clearTimeout(searchTimeout)

    if (
      (!user?.firstname || user.firstname.length < length) &&
      (!user?.surname || user.surname.length < length)
    ) {
      setUserList([])
      return
    }

    searchTimeout = setTimeout(async () => {
      try {
        setLoadingUserList(true)
        let filter = {
          limit: 20,
          order_by:'surname'
        }
        if (user?.firstname) {
          filter.firstname = user?.firstname
        }
        if (user?.surname) {
          filter.surname = user?.surname
        }
        const allUser = await reservationServices.userReservtionFilter(filter)
        setUserList(allUser)
      } catch (error) {
        setUserList([])
      } finally {
        setLoadingUserList(false)
      }
    }, 1000)
  }

  const setUserSelected = (value) => {
    try {
      if (!value){
        handleFormChange('user_to',[])
      }else {
        handleFormChange('user_to',value)
      }
    } catch (error) {
      handleFormChange('user_to',[])
    }
  }

  const handleFormChange = (field, value) =>{
    if(formError[field] !== undefined){
      formError[field] = false
    }
    setForm({...form, [field]:value})
  }

  useEffect(()=>{
    setAnalysisPeriodExample(getDateRanges(form.date_filter_range))
  },[form.date_filter_range])

  const filterDatetypesBySubtype = () =>{
    if(form.subtype === 0){
      return datetypes.filter(type=>type.id !== 0)
    }
    return datetypes.filter(type=>type.id !== 7)
    
  }

  return (
    <div style={{margin:'15px', display:'flex', flexDirection:'column'}}>
      <Grid container>
        <Grid item lg={4} md={4} padding={'15px'}>
          {loadingEditInfo ? 
            <Skeleton sx={{ height:'50px',  width:'100%'}}/>
            :
            <>
              <label htmlFor="configuration"
                style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
              >
                {`${translate('ra.field.config')}*`}
                <InputAdornment position="end">
                      <Tooltip title="'A demanda' - Utilizado para reportes específicos a generar por única vez. 'Preconfigurado' - utilizado para programar reportes con cierta periodicidad o anticipación. ">
                        <IconButton edge="end">
                          <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
              </label>
              <TextField
                select
                id={'configuration'}
                size="small"
                sx={{ width:'100%'}}
                fullWidth
                disabled={reportId}
                variant="outlined"
                value={form.configuration}
                onChange={(e) => handleFormChange('configuration', e.target.value)}
                required
                error={formError.configuration}
              >
                {applyOrder(configurations).map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            </>
            }
          </Grid>
          <Grid item lg={4} md={4} padding={'15px'}>
              {loadingEditInfo ? 
              <Skeleton sx={{ height:'50px', width:'100%'}}/>
            :
            <>
              <label htmlFor="name"
                style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
              >
                {`${translate('ra.field.name')}*`}
                <InputAdornment position="end">
                      <Tooltip title="Ingresa en este campo un nombre para identificar fácilmente el reporte que recibas por mail y que adicionalmente verás en la sección de Reportes generados para su descarga.">
                        <IconButton edge="end">
                          <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
              </label>
              <TextField 
                required
                error={formError.name}
                value={form?.name} 
                disabled={isShow}
                onChange={(value)=>handleFormChange('name', value?.target.value)} 
                id='name' 
                size='small'
                sx={{width:'100%'}}
              />
            </>
            }
          </Grid>
          <Grid item lg={4} md={4} padding={'15px'}>
            {
              reportToEdit && 
              <FormControlLabel
                label={translate('ra.field.is_active')}
                control={
                  <Switch
                    disabled={isShow}
                    onChange={(val)=>setActiveChecked(val.target.checked)}
                    checked={activeChecked} 
                  />
                }
              />
            }
        </Grid>
      </Grid>
      <Grid container style={{borderBottomWidth:'1px', borderBottomStyle:'solid', borderBottomColor:'gray'}}>
        <Grid item lg={4} md={4} padding={'15px'}>
              {loadingEditInfo ? 
          <Skeleton sx={{width:'100%', height:'50px'}}/>
          :
          <>
            <label htmlFor="type"
              style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
            >
                {`${translate('ra.field.type')}*`}
                <InputAdornment position="end">
                  <Tooltip title="El tipo de reporte elegido definirá las columnas que se enviarán en el reporte solicitado y los filtros adicionales que puedan combinarse en la creación del mismo.">
                    <IconButton edge="end">
                      <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
            </label>
            <TextField
                select
                size="small"
                id='type'
                sx={{ width:'100%'}}
                fullWidth
                required
                error={formError.type}
                disabled={isShow}
                variant="outlined"
                value={form.type}
                onChange={(e) => handleFormChange('type', e.target.value)}
              >
                {applyOrder(types, 'name').map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.name}
                  </MenuItem>
                ))}
            </TextField>
          </>
          }
        </Grid>
        <Grid item lg={4} md={4} padding={'15px'}>
          {loadingEditInfo ? 
          <Skeleton sx={{width:'100%', height:'50px'}}/>
          :
          <>
            <label htmlFor="subtype"
              style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
            >
                {`${translate('ra.field.subtype')}*`}
                <InputAdornment position="end">
                  <Tooltip title="'Detallado por item' - El reporte sólo mostrará aquellos items que cumplan con las condiciones específicamente configuradas. 'Detallado general' - Todos los items de cada reserva serán mostrados en el reporte.">
                    <IconButton edge="end">
                      <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
            </label>
            <TextField
                select
                size="small"
                id='subtype'
                sx={{ width:'100%'}}
                fullWidth
                required
                error={formError.subtype}
                disabled={isShow || form.type === 9}
                variant="outlined"
                value={form.type === 9 ? null : form.subtype}
                onChange={(e) => handleFormChange('subtype', e.target.value)}
              >
                {applyOrder(subtypes).map((item) => (
                  <MenuItem key={item.id} value={item.id}>
                    {item.label}
                  </MenuItem>
                ))}
              </TextField>
            </>
          }
        </Grid>
      </Grid>
      <hr/>
      <Grid container style={{borderBottomWidth:'1px', borderBottomStyle:'solid', borderBottomColor:'gray'}}>
        <Grid item lg={8} padding={'15px'}>
              <>
              <label htmlFor='users'
                style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
              >
                {`${translate('ra.field.aditional_recipients')} (opcional)`}
                <InputAdornment position="end">
                  <Tooltip title="Todo reporte por default llegará a la casilla del creador. Utiliza este campo si precisas que otros usuarios lo reciban en copia y lo vean disponible en la sección de Reportes.">
                    <IconButton edge="end">
                      <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              </label>
              {isShow ? 
                <TextField
                  disabled
                  id='users'
                  sx={{ width:'100%'}}
                  fullWidth
                  size='small'
                  value={form.user_to.map(user=>user.firstname + ' ' + user.surname).join(', ')}
                />:
              <FormProvider {...usersForm}>
                  <MultiAutocompleteInput
                    source='user_to'
                    options={usersList}
                    loading={usersLoading}
                    multiple
                    id='users'
                    optionsText={['firstname', 'surname']}
                    optionValue='id'
                    onSearch={getUserB2}
                    resetOnLoad={false}
                    fields={['firstname', 'surname']}
                    onChange={(e) => setUserSelected(e?.target?.value)}
                    disablePortal={false}
                  />
            </FormProvider>
             }
             </>
        </Grid>
      </Grid>
      <hr/>
      <Grid container>
          {(form.configuration === 1 || form.configuration === 0) &&
            <Grid item lg={4} md={4} padding={'15px'}>
              {loadingEditInfo ? 
              <Skeleton sx={{width:'100%', height:'50px'}}/>
              :
              <>
                <label htmlFor="date_type"
                  style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
                >
                  {`${translate('ra.field.date_type')}*`}
                  <InputAdornment position="end">
                    <Tooltip title="Elige del listado el tipo de fecha principal que determinará las operaciones a analizar. Podrás combinarlo con otros tipos de fecha desde la opción 'Agregar filtro' que se muestra más abajo.">
                      <IconButton edge="end">
                        <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                </label>
              
                <TextField
                  select
                  size="small"
                  sx={{width:'100%'}}
                  fullWidth
                  variant="outlined"
                  disabled={isShow}
                  id='date_type'
                  required
                  error={formError.date_filter_type}
                  value={form.date_filter_type}
                  onChange={(e) => {
                    handleFormChange('date_filter_type', e.target.value);
                    changeTypeDateFilters(e.target.value)
                  }}
                >
                  {applyOrder(filterDatetypesBySubtype()).map((item) => (
                    <MenuItem key={item.id} value={item.id}>
                      {item.label}
                    </MenuItem>
                  ))}
                </TextField>
              </>
              }
            </Grid>
          }
          {(form.configuration === 1) &&(
          <>
          <Grid item lg={4} md={4} padding={'15px'} style={{display:'flex', flexDirection:'column',justifyContent:'space-between'}}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                  <label htmlFor="from" style={{marginBottom:'10px'}}>
                    {`${translate('ra.field.from')}*`}
                  </label>
                  <DatePicker
                      value={form.dateFrom || null}
                      id='from'
                      disabled={isShow}
                      minDate={form.dateTo && (new Date(form.dateTo)).setDate((new Date(form.dateTo))?.getDate() - 60)}
                      maxDate={form.dateTo}
                      onChange={(date) => handleFormChange('dateFrom', (date && (new Date(date)) instanceof Date && !isNaN(date)) ? (new Date(date)) : null)}
                      renderInput={(params) => (
                        <TextField {...params} required error={formError.dateFrom} style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                      )}
                    />
                </LocalizationProvider>
          </Grid>
          <Grid item lg={4} md={4} padding={'15px'} style={{display:'flex', flexDirection:'column',justifyContent:'space-between'}}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                  <label htmlFor="to" style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}>
                    {`${translate('ra.field.to')}*`}
                    <InputAdornment position="end">
                      <Tooltip title={translate('ra.message.onDemandDateAclaration')}>
                        <IconButton edge="end">
                          <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  </label>
                  <DatePicker
                      value={form.dateTo || null}
                      id='to'
                      disabled={isShow}
                      maxDate={form.dateFrom && (new Date(form.dateFrom)).setDate((new Date(form.dateFrom))?.getDate() + 60)}
                      onChange={(date) => handleFormChange('dateTo', (date && (new Date(date)) instanceof Date && !isNaN(date)) ? (new Date(date)) : null)}
                      minDate={form.dateFrom }
                      renderInput={(params) => (
                        <TextField {...params} required error={formError.dateTo} style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                      )}
                    />
                </LocalizationProvider>
          </Grid>
          </>)}
          {(form.configuration === 0) &&(
            <>
              <Grid item lg={4} md={4} padding={'15px'}>
                {loadingEditInfo ? 
                  <Skeleton sx={{width:'100%', height:'50px'}}/>
                :
                <>
                  <label htmlFor="analysis_period"
                    style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
                  >
                    {`${translate('ra.field.analysis_period')}*`}
                    <InputAdornment position="end">
                    <Tooltip title="Elige del listado el período a analizar. ">
                      <IconButton edge="end">
                        <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
                  </label>
                
                  <TextField
                      select
                      size="small"
                      sx={{width:'100%'}}
                      required
                      error={formError.date_filter_range}
                      fullWidth
                      disabled={isShow}
                      variant="outlined"
                      id='analysis_period'
                      value={form.date_filter_range}
                      onChange={(e) => handleFormChange('date_filter_range', e.target.value)}
                    >
                      {applyOrder(analisysPeriod).map((item) => (
                        <MenuItem key={item.id} value={item.id}>
                          {item.label}
                        </MenuItem>
                      ))}
                    </TextField>
                    <label style={{color:'#6f7ce0'}}>
                      {analysisPeriodExample?
                        ` Ejemplo de referencia: ${analysisPeriodExample.start} - ${analysisPeriodExample.end}. El reporte se generará con esta misma lógica en base a la periodicidad definida.`
                      :
                      ''
                      }
                    </label>
                  </>
                  }
              </Grid>
              <Grid item lg={4} md={4} padding={'15px'}>
                  {loadingEditInfo ? 
                <Skeleton sx={{width:'100%', height:'50px'}}/>
                :
                <>
                  <label htmlFor="sending_frequency"
                    style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
                  >
                    {`${translate('ra.field.sending_frequency')}*`}
                    <InputAdornment position="end">
                      <Tooltip title="Establece con qué frecuencia y cuándo deseas recibir cada reporte.">
                        <IconButton edge="end">
                          <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                        </IconButton>
                      </Tooltip>
                    </InputAdornment>
                  </label>
                  <TextField
                    select
                    size="small"
                    sx={{width:'100%'}}
                    fullWidth
                    required
                    error={formError.type_frequency}
                    disabled={isShow}
                    variant="outlined"
                    id='sending_frequency'
                    value={form.type_frequency}
                    onChange={(e) =>{
                      setForm({...form,type_frequency:e.target.value, frequency:[]}); 
                      setUniqueDateFrequency(null)
                    }}
                  >
                    {sendingPeriods.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                </>
                }
              </Grid>
            </>
          )}
      {(form.date_filter_range === 13 && form.configuration === 0) &&(
        <>
          <Grid item lg={4} md={4} padding={'15px'} style={{display:'flex', flexDirection:'column',justifyContent:'space-between'}}>
                <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                  <label htmlFor="from" style={{marginBottom:'10px'}}>
                    {`${translate('ra.field.from')}*`}
                  </label>
                  <DatePicker
                      value={form.custom__gte || null}
                      id='from'
                      disabled={isShow}
                      maxDate={form.custom__lte || null}
                      onChange={(date) => {
                        if((date && (new Date(date)) instanceof Date && !isNaN(date))){
                          const customDate = new Date(date);
                          const date_str = `${customDate.getFullYear()}-${String(customDate.getMonth()+1).padStart(2,'0')}-${String(customDate.getDate()).padStart(2,'0')}T00:00:00`;
                          handleFormChange('custom__gte', date_str)
                        } else {
                          handleFormChange('custom__gte', null)
                        }
                      }}
                      renderInput={(params) => (
                        <TextField {...params} required error={formError.custom__gte} style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                      )}
                    />
                </LocalizationProvider>
          </Grid>
          <Grid item lg={4} md={4} padding={'15px'} style={{display:'flex', flexDirection:'column',justifyContent:'space-between'}}>
              <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='es'>
                  <label htmlFor="to" style={{marginBottom:'10px'}}>
                    {`${translate('ra.field.to')}*`}
                  </label>
                  <DatePicker
                      value={form.custom__lte || null}
                      id='to'
                      disabled={isShow}
                      onChange={(date) =>{
                        if((date && (new Date(date)) instanceof Date && !isNaN(date))){
                          const customDate = new Date(date);
                          const date_str = `${customDate.getFullYear()}-${String(customDate.getMonth()+1).padStart(2,'0')}-${String(customDate.getDate()).padStart(2,'0')}T23:59:59`;
                          handleFormChange('custom__lte', date_str)
                        } else {
                          handleFormChange('custom__lte', null)
                        }
                      }}
                      minDate={form.custom__gte || null }
                      renderInput={(params) => (
                        <TextField {...params} required error={formError.custom__lte} style={{width:'100%'}} fullWidth variant='outlined' size='small' />
                      )}
                    />
                </LocalizationProvider>
          </Grid>
        </>)}
      </Grid>
      {(form.configuration === 2) &&<Grid container>
          <Grid item lg={4} md={4} padding={'15px'}>
              <label htmlFor="reservation_number"
                style={{display:'flex', flexDirection:'row', alignItems:'center', marginBottom:'10px'}}
              >
                {`${translate('ra.field.reservation_number')}*`}
                <InputAdornment position="end">
                  <Tooltip title="Permite generar un reporte en base a números de reservas específicos. Utilizar comas sin espacio para consultar más de una. No hay límite de cantidad.">
                    <IconButton edge="end">
                      <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              </label>
              <TextField 
                value={form?.number__in} 
                disabled={isShow}
                required
                error={formError.number__in}
                id='reservation_number'
                onChange={(value)=>handleFormChange('number__in', value?.target.value)} 
                size='small' 
                sx={{width:'100%'}}
              />
          </Grid>
      </Grid>}
      {form.configuration === 0 &&
      <>
      {form.type_frequency !== null &&
      <Grid container>
        <Grid item lg={4} md={4} padding={'15px'}>
          {
              form.type_frequency === 1 && (
                <div style={{display:'flex', flexDirection:'row'}}> 
                  {
                    weekDays.map((day, index)=>(
                      <Chip 
                        key={index}
                        style={{marginRight:'10px', cursor:'pointer'}} 
                        label={day}
                        disabled={isShow}
                        variant={form.frequency.includes(index) ? 'filled' : "outlined"}
                        onClick={()=>{
                          let auxFreq = [...form.frequency]
                          if(auxFreq.includes(index)){
                            auxFreq = auxFreq.filter(freq=>freq !== index)
                          } else {
                            auxFreq.push(index)
                          }
                          handleFormChange('frequency', auxFreq)
                        }}
                      />
                    ))
                  }
                </div>
              )
            }
            {
              form.type_frequency === 3 && (
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <label htmlFor="frequency" style={{marginBottom:'10px'}}>
                    {`${translate('ra.field.frequency')}*`}
                  </label>
                  <DatePicker 
                      id='frequency'
                      value={uniqueDateFrequency}
                      inputFormat="DD/MM/YYYY"
                      minDate={tomorrow}
                      disabled={isShow}
                      maxDate={maxDate}
                      renderInput={(params)=>(
                          params &&
                          <TextField 
                              {...params}
                              required
                              error={formError.frequency}
                              size='small'
                              style={{ width:'100%'}}
                          />
                      )}
                      onChange={(value)=>{
                        if((value && (new Date(value)) instanceof Date && !isNaN(value))){
                          if(value > (new Date())){
                            setDynamicDateValidation(false)
                            setUniqueDateFrequency(value)
                            handleFormChange('frequency',value ? [value['$D']]:null)
                          } else {
                            setFormError({...formError, frequency:true})
                            handleFormChange('frequency',null)
                            setDynamicDateValidation(true)
                          }
                        } else {
                          handleFormChange('frequency',null)
                        }
                      }} 
                  />
                  {dynamicDateValidation && <label htmlFor="frequency" style={{marginBottom:'10px'}}>
                    {translate('ra.message.uniqueDateValidation')}
                  </label>}
              </LocalizationProvider>
              )
            }
            {form.type_frequency === 2 &&
            <>
            
              <Button 
                onClick={()=>setOpenMonthlyDialog(true)}
                size='small'
                variant='outlined'
                disabled={isShow}
                sx={{width:'100%'}}
              >
                {`${translate('ra.action.edit')} ${translate('ra.field.frequency')}`}
              </Button>
            </>
            }
        </Grid>
      </Grid>}
      {form.type_frequency !== 3 && <Grid container>
          <Grid item lg={8} md={8} padding={'15px'}>
              {loadingEditInfo ? 
                <Skeleton sx={{width:'100%', height:'50px'}}/>
              :
              <>
                <label htmlFor="frequencies" style={{marginBottom:'10px'}}>
                  {`${translate('ra.field.frequencies')}*`}
                </label>
              <TextField
                disabled
                value={stringfyFrequency()}
                required
                sx={{
                  width:'100%',
                  "& .MuiOutlinedInput-root.Mui-disabled": {
                    color: (formError.frequency && form.type_frequency !== 0) ?"red":'', // text color
                    "& fieldset": {
                      borderColor: (formError.frequency && form.type_frequency !== 0)?"red" :'', // outline color
                    },
                  },
                  "& .MuiFormHelperText-root.Mui-error": {
                    color: (formError.frequency && form.type_frequency !== 0)? "red":'',
                  },
                }}
                error={(formError.frequency && form.type_frequency !== 0)}
                id='frequencies'
                size='small'
              />
              </>
              }
          </Grid>
      </Grid>}
      </>
      }
      <Grid container>
        <Grid item lg={12} md={12} padding={'15px'}>
          <div style={{width:'100%'}}>
            
            {!isShow && 
            
            (<div style={{display:'flex', flexDirection:'row', marginBottom:'15px', alignItems:'center'}}>
              <Filters displayedFilters={displayedFilters} setFilters={setFilters} listFilters={listFilters} setFilterValues={setFilterValues}/>
              <InputAdornment position="end">
                    <Tooltip title="Combina filtros adicionales para generar reportes más específicos.">
                      <IconButton edge="end">
                        <InfoOutlinedIcon color='info' style={{height:'20px'}}/>
                      </IconButton>
                    </Tooltip>
                  </InputAdornment>
            </div>)}
            
            <PostFilterFormReservation 
              setFormError={setFormError}
              displayedFilters = {displayedFilters} 
              filterValues = {filterValues} 
              setFilters={setFilters} 
              initialFields={form} 
              reportToEdit={reportToEdit} 
              setOpenEditDialog={setOpenEditDialog}
              isShow={isShow}
            />
          </div>
        </Grid>
      </Grid>
        
        <Dialog open={openMonthlyDialog} onClose={()=>setOpenMonthlyDialog(false)}>
          <DialogTitle>
            {`${translate('ra.action.select')} ${translate('ra.field.frequency')}`}
          </DialogTitle>
          <DialogContent>
            <MonthlyFrequenciesDialog frequencies={form.frequency} handleFormChange={handleFormChange} setOpenMonthlyDialog={setOpenMonthlyDialog}/>
          </DialogContent>
        </Dialog>
    </div>
  )
}
